/* sm-about-parallax — port of Manukora parallax-images.js (scale 1.2 -> 1 as the image travels up the viewport).
   Any element with [data-sm-parallax] is tracked. Singleton; safe to load from several sections. */
(function () {
  if (window.SmAboutParallax) { window.SmAboutParallax.refresh(); return; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = [], ticking = false, visible = new Set(), observer = null;
  function cache(el) { var r = el.getBoundingClientRect(); return { el: el, top: r.top + window.pageYOffset, h: r.height, last: null }; }
  function update(d, wh, sy, initial) {
    var top = d.top - sy, bottom = top + d.h;
    if (!initial && (top > wh + 100 || bottom < -100)) return;
    var p = top >= wh ? 0 : bottom <= 0 ? 1 : (wh - top) / (wh + d.h);
    p = Math.max(0, Math.min(1, p));
    var s = Math.round((1.2 - 0.2 * p) * 1000) / 1000;
    if (d.last !== null && Math.abs(d.last - s) < 0.001) return;
    d.last = s; d.el.style.transform = 'scale(' + s + ')';
  }
  function all(initial) {
    var wh = window.innerHeight, sy = window.pageYOffset;
    items.forEach(function (d) { if (initial || !observer || visible.has(d.el)) update(d, wh, sy, initial); });
  }
  function tick() { if (ticking) return; ticking = true; requestAnimationFrame(function () { all(false); ticking = false; }); }
  function refresh() {
    if (reduce) return;
    items = Array.prototype.map.call(document.querySelectorAll('[data-sm-parallax]'), cache);
    if (observer) observer.disconnect();
    visible.clear();
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? visible.add(e.target) : visible.delete(e.target); }); }, { rootMargin: '50px 0px' });
      items.forEach(function (d) { observer.observe(d.el); });
    }
    all(true);
  }
  window.addEventListener('scroll', tick, { passive: true });
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(refresh, 150); }, { passive: true });
  window.addEventListener('load', refresh);
  if (document.readyState !== 'loading') refresh(); else document.addEventListener('DOMContentLoaded', refresh);
  window.SmAboutParallax = { refresh: refresh };
})();
